<template>
  <v-expansion-panels v-model="panel" multiple focusable class="mt-4">
    <v-expansion-panel readonly>
      <v-expansion-panel-header hide-actions>
        <v-row no-gutters class="text-center font-weight-bold">
          <v-col cols="2" class="pr-2">Data</v-col>
          <v-col cols="2" class="pr-1">Tempo Online</v-col>
          <v-col cols="3" class="pr-4">Tempo Disponível</v-col>
          <v-col cols="2" class="pr-7">Tempo Pausado</v-col>
          <v-col cols="3" class="pr-8">Tempo em Ligação</v-col>
        </v-row>
      </v-expansion-panel-header>
    </v-expansion-panel>
    <v-expansion-panel v-for="(dadoRelatorio, key) in operadoresData" :key="key">
      <v-expansion-panel-header ripple>
        <v-row class="text-center" no-gutters>
          <v-col cols="2">{{ moment(dadoRelatorio.data, 'DD-MM-YYYY').format('DD/MM/YYYY') }}</v-col>
          <v-col cols="2">{{ dadoRelatorio.horaOnline }}</v-col>
          <v-col cols="3">{{ dadoRelatorio.horaDisponivel }}</v-col>
          <v-col cols="2">{{ dadoRelatorio.horaPausado }}</v-col>
          <v-col cols="3">{{ dadoRelatorio.horaEmLigacao }}</v-col>
        </v-row>
        <template v-slot:actions>
          <v-icon color="orangePcm">$expand</v-icon>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content color="background">
        <v-row justify="center">
          <v-col cols="8">
            <v-data-iterator
              :no-data-text="noDataText"
              :items="pausasPorDia(dadoRelatorio.data)"
              :items-per-page.sync="itemsPerPage"
              :page="page"
              :search="search"
              :no-results-text="noResultsText"
              hide-default-footer
            >
              <template v-slot:header>
                <v-row justify="end">
                  <v-col cols="4">
                    <v-text-field
                      v-model="search"
                      clearable
                      hide-details
                      prepend-inner-icon="mdi-magnify"
                      label="Busca"
                    />
                  </v-col>
                </v-row>
              </template>
              <template v-slot:default="props">
                <v-data-table
                  dense
                  :headers="headers"
                  :items="props.items"
                  hide-default-footer
                  class="elevation-1"
                  disable-pagination
                  disable-sort
                >
                  <template v-slot:[`item.tempo`]="{ item }">
                    <div :class="`${getColor(item)}--text`">
                      {{ item.tempo }}
                    </div>
                  </template>
                </v-data-table>
              </template>

              <template v-slot:footer>
                <v-row class="mt-2" align="baseline" justify="center" dense>
                  <div class="ml-4 mb-2 grey--text">
                    <p>Pausas Distintas: {{ pausasPorDia(dadoRelatorio.data).length }}</p>
                  </div>
                  <v-spacer />
                  <div class="pb-5">
                    <ListPagination
                      :page="page"
                      :numberOfPages="numberOfPages(dadoRelatorio.data)"
                      @firstPage="firstPage()"
                      @formerPage="formerPage()"
                      @nextPage="nextPage()"
                      @lastPage="lastPage()"
                    />
                  </div>
                </v-row>
              </template>
            </v-data-iterator>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import moment from 'moment'

import ListPagination from '@/componentes/ListPagination'

export default {
  name: 'ExpandListInterno',
  props: ['dadosOperador'],
  components: { ListPagination },
  data: () => ({
    noDataText: process.env.VUE_APP_NO_DATA_TEXT,
    noResultsText: process.env.VUE_APP_NO_RESULTS_TEXT,
    panel: [],
    operadoresData: [],
    dadosPorTipoDePausa: [],
    itemsPerPage: 20,
    page: 1,
    search: '',
    headers: [
      {
        text: 'Pausa',
        value: 'pausa',
        align: 'left',
      },
      {
        text: 'Quantidade',
        value: 'quantidade',
        align: 'right',
      },
      {
        text: 'Tempo',
        value: 'tempo',
        align: 'left',
      },
    ],
    moment: moment,
  }),

  computed: {
    qtdRegistros() {
      return this.dadosPorTipoDePausa.length
    },
  },

  methods: {
    numberOfPages(dataDaPausa) {
      return Math.ceil(this.pausasPorDia(dataDaPausa).length / this.itemsPerPage)
    },

    pausasPorDia(dataDaPausa) {
      return this.dadosPorTipoDePausa.filter(dado => dado.data === dataDaPausa)
    },

    getColor(item) {
      let limitePausaMoment = moment.duration(item.limitePausa, 'HH:mm').asSeconds()
      let tempoPausaMoment = moment.duration(item.tempo, 'HH:mm:ss').asSeconds()

      if (tempoPausaMoment > limitePausaMoment) {
        return 'font-weight-bold red'
      } else {
        return 'black'
      }
    },

    firstPage() {
      if (this.page > 1) {
        this.page = 1
      }
    },

    formerPage() {
      if (this.page > 1) {
        this.page = this.page - 1
      }
    },

    nextPage() {
      if (this.page < this.numberOfPages) {
        this.page = this.page + 1
      }
    },

    lastPage() {
      if (this.page < this.numberOfPages) {
        this.page = this.numberOfPages
      }
    },
  },

  watch: {
    dadosOperador: {
      deep: true,
      immediate: true,
      handler() {
        this.operadoresData.splice(0)
        this.dadosPorTipoDePausa.splice(0)
        let datas = Object.keys(this.dadosOperador.horasPorDia)
        let values = Object.values(this.dadosOperador.horasPorDia)

        for (let i = 1; i < datas.length; i++) {
          let horaDisponivel
          let horaEmLigacao
          let horaPausado
          let horaOnline

          if (values[i].horaDisponivel) {
            horaDisponivel = values[i].horaDisponivel
          } else {
            horaDisponivel = '00:00:00'
          }

          if (values[i].horaEmLigacao) {
            horaEmLigacao = values[i].horaEmLigacao
          } else {
            horaEmLigacao = '00:00:00'
          }

          if (values[i].horaPausado) {
            horaPausado = values[i].horaPausado
          } else {
            horaPausado = '00:00:00'
          }

          if (values[i].horaOnline) {
            horaOnline = values[i].horaOnline
          } else {
            horaOnline = '00:00:00'
          }

          this.operadoresData.push({
            data: datas[i],
            TempoPausaPorTipoDePausa: values[i].TempoPausaPorTipoDePausa,
            horaDisponivel,
            horaEmLigacao,
            horaPausado,
            horaOnline,
          })

          if (typeof values[i].TempoPausaPorTipoDePausa !== 'undefined') {
            let dadosPorTipoDePausa = {}
            let keysPausas = Object.keys(values[i].TempoPausaPorTipoDePausa)
            let valuesPausas = Object.values(values[i].TempoPausaPorTipoDePausa)

            for (let j = 0; j < keysPausas.length; j++) {
              dadosPorTipoDePausa = {
                pausa: keysPausas[j],
                quantidade: valuesPausas[j].quantidade,
                tempo: valuesPausas[j].seconds,
                limitePausa: valuesPausas[j].duration,
                data: datas[i],
              }
              this.dadosPorTipoDePausa.push(dadosPorTipoDePausa)
            }
          }
        }
      },
    },
  },
}
</script>
